import styled from 'styled-components';

export const RatingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
